<template>
  <div class="home-page">
    <!-- 顶部品牌Banner -->
    <div class="banner" :style="{ backgroundImage: 'url(/index_bg.png)' }">
      <div class="banner-content">
        <h1 class="brand-name">优行运车</h1>
        <p class="brand-slogan">专业的二手车代驾平台</p>
      </div>
    </div>

    <!-- 悬浮标题栏 + 任务列表 -->
    <div class="task-section">
      <div class="task-header">
        <span>今日任务</span>
      </div>

      <div class="task-body">
        <!-- 加载中 -->
        <div v-if="loading" class="loading-state">
          <div v-for="n in 3" :key="n" class="skeleton-card">
            <div class="skeleton-line w50"></div>
            <div class="skeleton-line w70"></div>
            <div class="skeleton-line w70"></div>
            <div class="skeleton-line w60"></div>
          </div>
        </div>

        <!-- 有数据：任务列表 -->
        <div v-else-if="tasks.length" class="task-list">
          <div
            v-for="task in tasks"
            :key="task.id"
            class="task-card"
            @click="handleTaskClick(task)"
          >
            <div class="task-time-row">
              <span class="task-time">
                <i class="dot dot-gray"></i>
                {{ task.add_time }}
              </span>
              <span class="task-status">{{ task.daijiaServerStatusText }}</span>
            </div>
            <div class="task-route">
              <div class="route-point route-start">
                <i class="dot dot-blue"></i>
                <span>{{ task.start_city_name }}</span>
              </div>
              <div class="route-point route-end">
                <i class="dot dot-orange"></i>
                <span>{{ task.end_city_name }}</span>
              </div>
            </div>
            <div class="task-footer">
              <span class="task-tag">{{ task.channelText }}</span>
              <span class="task-deadline">规定交车时间 {{ task.estimate_start_time }}</span>
              <button
                v-if="task.daijia_server_status == 0"
                class="task-grab-btn"
                @click.stop="handleAgree(task)"
              >接单</button>
            </div>
          </div>
        </div>

        <!-- 无数据：空状态 -->
        <div v-else class="empty-state">
          <svg class="empty-icon" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="30" y="20" width="50" height="65" rx="4" stroke="#333" stroke-width="2.5"/>
            <line x1="40" y1="35" x2="70" y2="35" stroke="#333" stroke-width="2" stroke-linecap="round"/>
            <line x1="40" y1="45" x2="70" y2="45" stroke="#333" stroke-width="2" stroke-linecap="round"/>
            <line x1="40" y1="55" x2="60" y2="55" stroke="#333" stroke-width="2" stroke-linecap="round"/>
            <circle cx="82" cy="78" r="18" stroke="#333" stroke-width="2.5"/>
            <line x1="95" y1="91" x2="105" y2="101" stroke="#333" stroke-width="3" stroke-linecap="round"/>
            <path d="M75 78 L79 82 L89 72" stroke="#4A90E2" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="20" cy="30" r="2" fill="#FF9500"/>
            <circle cx="100" cy="25" r="1.5" fill="#4A90E2"/>
            <circle cx="15" cy="80" r="1.5" fill="#FF9500"/>
            <path d="M95 15 L97 20 L102 22 L97 24 L95 29 L93 24 L88 22 L93 20 Z" fill="#4A90E2" opacity="0.5"/>
          </svg>
          <p class="empty-text">暂无数据</p>
        </div>
      </div>
    </div>

    <TabBar />

    <!-- 合同签约提示弹窗 -->
    <div v-if="showSignModal" class="sign-mask" @click="showSignModal = false">
      <div class="sign-modal" @click.stop>
        <p class="sign-text">您的合同尚未签约，请先签约合同！</p>
        <div class="sign-btns">
          <button class="sign-btn cancel-btn" @click="showSignModal = false">取消</button>
          <button class="sign-btn confirm-btn" @click="handleSignNow">立即签约</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/TabBar.vue'
import { getMyOrders, robOrder, agreePush, getSignUp } from '@/api/order'
import { setLat, setLng } from '@/utils/auth'

const STATUS_MAP = {
  0: '未接单',
  1: '已接单',
  2: '服务中',
  3: '已完成'
}

export default {
  name: 'Home',
  components: { TabBar },
  data() {
    return {
      loading: false,
      tasks: [],
      showSignModal: false
    }
  },
  created() {
    this.getLocation()
    this.fetchTasks()
  },
  methods: {
    getLocation() {
      if (!window.isSecureContext) {
        // this.$message.warning('当前为HTTP环境，定位功能需HTTPS支持')
        return
      }
      if (!navigator.geolocation) {
        this.$message.warning('您的浏览器不支持定位功能，部分功能可能受限')
        return
      }
      navigator.geolocation.getCurrentPosition(
        pos => {
          setLat(pos.coords.latitude)
          setLng(pos.coords.longitude)
        },
        err => {
          let msg = '获取定位失败'
          if (err.code === 1) msg = '定位权限被拒绝，请在浏览器设置中允许定位'
          else if (err.code === 2) msg = '定位信息不可用，请检查GPS是否开启'
          else if (err.code === 3) msg = '定位超时，请重试'
          this.$message.warning(msg)
        }
      )
    },
    async fetchTasks() {
      this.loading = true
      try {
        const res = await getMyOrders({ page: 1, size: 20,status: '0,1,2'})
        const list = res.data && res.data.list ? res.data.list : []
        this.tasks = list
      } catch (err) {
        this.tasks = []
      } finally {
        this.loading = false
      }
    },
    handleTaskClick(task) {
      this.$router.push({
        path: '/order-detail',
        query: { id: task.id }
      })
    },
    async handleAgree(task) {
      try {
        const res = await agreePush(task.id)
        if (res.code === 0) {
          this.$message.success('接单成功')
          this.fetchTasks()
        } else if (res.code === 2) {
          this.showSignModal = true
        } else {
          this.$message.error(res.msg || '接单失败，请重试')
        }
      } catch (err) {
        this.$message.error(err.message || '接单失败')
      }
    },
    async handleSignNow() {
      this.showSignModal = false
      try {
        const res = await getSignUp()
        if (res.code === 0 && res.data && res.data.url) {
          window.location.href = res.data.url
        } else {
          this.$message.error(res.msg || '获取合同链接失败')
        }
      } catch (err) {
        this.$message.error(err.message || '获取合同链接失败')
      }
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 56px;
}

/* 品牌Banner */
.banner {
  position: relative;
  height: 150px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  padding: 40px 20px 0;
}

.banner-content {
  position: relative;
  z-index: 1;
}

.brand-name {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  margin-bottom: 6px;
}

.brand-slogan {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
}

/* 任务区域 */
.task-section {
  margin: 15px 0 0;
  position: relative;
  z-index: 2;
}

.task-header {
  margin: 0 16px;
  padding: 14px 16px;
  background: #4a90e2;
  border-radius: 16px 16px 0 0;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.task-body {
  margin: 0 16px;
  background: #fff;
  border-radius: 0 0 16px 16px;
  min-height: 320px;
  padding: 0 16px;
}

/* 任务卡片 */
.task-card {
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.task-card:last-child {
  border-bottom: none;
}

.task-card:active {
  background: #fafafa;
}

.task-time-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.task-time {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
}

.task-status {
  font-size: 13px;
  color: #999;
}

.task-route {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
}

.route-point {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #333;
  font-weight: 500;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}

.dot-gray { background: #ccc; }
.dot-blue { background: #4a90e2; }
.dot-orange { background: #ff9500; }

.task-footer {
  display: flex;
  align-items: center;
}

.task-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: #ff9500;
  color: #fff;
  font-size: 11px;
  border-radius: 4px;
  margin-right: 8px;
  white-space: nowrap;
}

.task-deadline {
  font-size: 12px;
  color: #ff9500;
}

.task-grab-btn {
  margin-left: auto;
  padding: 4px 16px;
  background: #4a90e2;
  color: #fff;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  white-space: nowrap;
}

.task-grab-btn:active {
  background: #3a7bd5;
}

/* 骨架屏 */
.skeleton-card {
  padding: 16px 0;
  border-bottom: 1px solid #eee;
}

.skeleton-line {
  height: 14px;
  background: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 12px;
  animation: skeleton-pulse 1.2s ease-in-out infinite;
}

.w50 { width: 50%; }
.w60 { width: 60%; }
.w70 { width: 70%; }

@keyframes skeleton-pulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
}

.empty-icon {
  width: 120px;
  height: 120px;
}

.empty-text {
  margin-top: 24px;
  font-size: 16px;
  color: #333;
}

/* 加载中 */
.loading-state {
  padding-top: 0;
}

/* 签约提示弹窗 */
.sign-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.sign-modal {
  width: 80%;
  max-width: 320px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  animation: sign-in 0.25s ease;
}

@keyframes sign-in {
  from { transform: scale(0.85); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.sign-text {
  padding: 32px 24px 24px;
  text-align: center;
  font-size: 16px;
  color: #333;
  line-height: 1.6;
}

.sign-btns {
  display: flex;
  border-top: 1px solid #eee;
}

.sign-btn {
  flex: 1;
  height: 48px;
  border: none;
  font-size: 16px;
  background: transparent;
  cursor: pointer;
}

.sign-btn.cancel-btn {
  color: #999;
  border-right: 1px solid #eee;
}

.sign-btn.cancel-btn:active {
  background: #f5f5f5;
}

.sign-btn.confirm-btn {
  color: #4a90e2;
  font-weight: 500;
}

.sign-btn.confirm-btn:active {
  background: #f0f7ff;
}
</style>
